import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';

export default ChevronRightRoundedIcon;
